module.exports = __webpack_public_path__ + "img/WBPad-线标.f91d9960.svg";